import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FootPrintIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5.692 3.907c.304 1.456-.258 3.052-.585 3.842a.489.489 0 0 1-.377.294l-1.882.3a.461.461 0 0 1-.455-.183 8.486 8.486 0 0 1-1.297-3.144c-.38-2.041.379-3.772 2.037-3.994C4.792.8 5.351 2.274 5.692 3.907ZM3.207 9.635l1.921-.403a.497.497 0 0 1 .571.315c.35.97.68 2.243-.765 2.437-1.268.17-1.904-1.023-2.08-1.853-.05-.235.118-.446.353-.496ZM10.308 6.907c-.304 1.456.258 3.052.585 3.842a.489.489 0 0 0 .377.294l1.882.3a.462.462 0 0 0 .455-.183 8.488 8.488 0 0 0 1.297-3.144c.38-2.041-.379-3.772-2.037-3.994-1.659-.222-2.218 1.252-2.559 2.885ZM12.793 12.635l-1.921-.403a.497.497 0 0 0-.571.315c-.35.97-.68 2.243.765 2.437 1.268.17 1.904-1.023 2.08-1.853.05-.235-.118-.446-.354-.496Z"
		/>
	</svg>
))
